import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  FormControl,
  TextField,
  FormHelperText,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import {
  auth,
  GoogleAuthProvider,
  signInWithPopup,
} from "../../config/firebase.config";
import { ErrorEvent, SignUpEvent } from "../../config/analytics";
import { useAuth } from "../../contexts/AuthContext";
import { fetchWithOptionalAuth } from "../../api/fetchWithAuth";
import ModalXLogo from "../../assets/signup/loginPageLogo.png";
import { useWorkspace } from "../../contexts/WorkspaceContext";
import { useUI } from "../../contexts/UIContext";
import { disposableEmailProviders } from "../../constants/disposableEmailDomains";
import {
  button_bg_color_for_New_Project_dm,
  uploadFiles_button_default_bg_color,
  uploadFiles_button_hovered_bg_color,
} from "../../constants/colors";
import { useNavigate } from "react-router-dom";
import CommonToast from "../Common_Components/CommonToast";

const SignUpLogInLayout = ({ setCurrentWindow, route }) => {
  const isBelow991 = useMediaQuery("(max-width:991px)");
  const [isInvalidEmail, setIsInvalidEmail] = useState(false);
  const [notifVariant, setNotifVariant] = useState("");
  const [notifMsg, setNotifMsg] = useState("");
  const [open, setOpen] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { email, setEmail } = useWorkspace();
  const { setUser } = useAuth();
  const { currentTheme } = useUI();
  const navigate = useNavigate();

  const handleCloseToast = () => {
    setOpen(false);
  };

  const isDisposableEmail = (email) => {
    const emailDomain = email.split("@")[1];
    return disposableEmailProviders.includes(emailDomain);
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    if (isDisposableEmail(newEmail)) {
      setIsInvalidEmail(true);
    } else {
      setIsInvalidEmail(false);
    }
  };

  function isValidEmail(value) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(value)) {
      return true;
    }
    return false;
  }

  // const handleContinueButtonOfCheckEmail = async (email) => {
  //   //logic to what window open signup next window or login after verfy from firebase
  //   if (isDisposableEmail(email)) {
  //     setNotifMsg(
  //       "We do not accept temporary or disposable email addresses. Please use a permanent email."
  //     );
  //     setNotifVariant("error");
  //     setOpen(true);
  //     return;
  //   }
  //   if (email === "") {
  //     setNotifVariant("error");
  //     setOpen(true);
  //     setNotifMsg("Please enter your email");
  //     return;
  //   } if(!isValidEmail(email)){
  //     setNotifVariant("error");
  //     setOpen(true);
  //     setNotifMsg("Please enter Valid email");
  //   }
  //   else {
  //     try {
  //       const res = await axios.get(`${sourceUrl}/check-email?email=${email}`, {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       });
  //       console.log(res?.data?.data?.exists, "response user exist or not");
  //       if (res?.data?.data?.exists) {
  //         setCurrentWindow(2);
  //         navigate("/login");
  //       } else {
  //         navigate("/signup");
  //         setCurrentWindow(2);
  //       }
  //     } catch (error) {
  //       ErrorEvent(error, error.message);
  //       setNotifMsg(error.message || "Verification failed");
  //       setNotifVariant("error");
  //       setOpen(true);
  //       console.log("error", error);
  //     }
  //   }
  // };

  const handleContinueButtonOfCheckEmail = async (email) => {
  if (isLoading) return;
  if (isDisposableEmail(email)) {
    setNotifMsg(
      "We do not accept temporary or disposable email addresses. Please use a permanent email."
    );
    setNotifVariant("error");
    setOpen(true);
    return;
  }
  if (email === "") {
    setNotifVariant("error");
    setOpen(true);
    setNotifMsg("Please enter your email");
    return;
  }
  if (!isValidEmail(email)) {
    setNotifVariant("error");
    setOpen(true);
    setNotifMsg("Please enter valid email");
    return;
  }

  setIsLoading(true);
  try {
    const response = await fetchWithOptionalAuth(`/check-email?email=${encodeURIComponent(email)}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const resData = await response.json();
    console.log(resData?.data?.exists, "response user exist or not");
    if (resData?.data?.exists) {
      setCurrentWindow(2);
      navigate("/login");
    } else {
      navigate("/signup");
      setCurrentWindow(2);
    }
  } catch (error) {
    ErrorEvent(error, error.message);
    setNotifMsg(error.message || "Verification failed");
    setNotifVariant("error");
    setOpen(true);
    console.log("error", error);
  } finally {
    setIsLoading(false);
  }
};

  const verifyUser = async (email) => {
    try {
      const response = await fetchWithOptionalAuth(`/login/verify`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (data.status === false) {
        throw new Error("Only invited users will be able to use Modalx.ai");
      }
      return true;
    } catch (error) {
      return false;
    }
  };

  const handleGoogleSignUp = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);

      // ===================== Invited users check =====================
      // const isVerified = await verifyUser(result.user.email);
      // if (!isVerified) return;

      // ===============================================================
      if (result.user.emailVerified) {
        {
          result.user &&
            result.user.accessToken &&
            (await fetchWithOptionalAuth(`/profile`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({}),
            }));
        }

        const isVerified = await verifyUser(result.user.email);
        if (!isVerified) {
          await fetchWithOptionalAuth(`/profile`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({}),
          });
          return;
        }
        localStorage.setItem("current_thread_id", "");
        localStorage.setItem("current_history_id", "");
        setUser(result.user.emailVerified);
        localStorage.setItem("isLoggedIn", true);
        localStorage.setItem("userEmail", result.user.email);
        const token = await result.user.getIdToken();
        localStorage.setItem("token", token);
        localStorage.setItem("lastTokenRefresh", Date.now().toString());
        SignUpEvent("user_signup", "continue_with_google");
        window.location.href = "/workspace";
      } else {
        localStorage.setItem("isLoggedIn", "");
      }
    } catch (error) {
      console.error("Error signing up with Google:", error);
      ErrorEvent(error, error.message);
        setNotifMsg(`Error signing up with Google: ${error.message}`);
        setNotifVariant("error");
        setOpen(true);
    }
  };

  const handleOpenSignUpModal = () => {
    navigate("/signup");
  };

  const handleOpenLoginModal = () => {
    navigate("/login");
  };

  const customTextFieldStylesForInvalid = (isInvalid) => {
    return {
      "& .MuiInputLabel-root": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "0.5px",
        color: "var(--text-secondary)",
        "&.Mui-focused": {
          color: isInvalid ? "var(--text-error) !important" : "var(--text-secondary)",
        },
      },
      "& .MuiInputBase-input": {
        color: "var(--text-primary)",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: isInvalid ? "var(--text-error)" : "var(--border-input)",
        },
        "&:hover fieldset": {
          borderColor: isInvalid ? "var(--text-error)" : "var(--border-input)",
        },
        "&.Mui-focused fieldset": {
          borderColor: isInvalid
            ? "var(--text-error) !important"
            : "var(--border-focus) ",
        },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
        color: isInvalid ? "var(--text-error) !important" : "var(--text-secondary) ",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isInvalid
          ? "var(--text-error) !important"
          : "var(--border-input) ",
      },
    };
  };

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "340px",
        height: isBelow991 ? "" : "100vh",
        display: "flex",
        flexDirection: "column",
        alignSelf: "center",
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ marginTop: isBelow991 && 3 }}>
        <Box
          sx={{
            display: isBelow991 ? "none" : "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "140px",
            marginTop: 7,
          }}
        >
          <img
            src={ModalXLogo}
            alt={"logo"}
            style={{ width: "163px", height: "51px", filter: "var(--logo-filter)" }}
          />
        </Box>
        <Typography
          sx={{
            display: "flex",
            justifyContent: "center",
            fontFamily: "Inter",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "20px",
            color: "var(--text-primary)",
            marginBottom: "40px",
            alignSelf: "center",
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          {route === "login" ? "Welcome back" : "Create an account"}
        </Typography>
        <FormControl
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TextField
            type="email"
            onChange={(e) => {
              handleEmailChange(e);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleContinueButtonOfCheckEmail(email);
              }
            }}
            value={email}
            id="outlined-basic"
            label="Email address*"
            variant="outlined"
            sx={() => customTextFieldStylesForInvalid(isInvalidEmail)}
            style={{
              width: "100%",
              maxWidth: "340px",
              height: "56px",
              color: "var(--text-primary)",
              backgroundColor: "var(--bg-input)",
              borderRadius: "8px",
              boxShadow: "var(--shadow-input)",
              placeholderfontsize: "16px",
            }}
          />
          <FormHelperText
            sx={{
              color: isInvalidEmail
                ? "var(--text-error)"
                : "var(--text-link)",
              fontFamily: "Inter",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "16px",
              alignSelf: "start",

              margin: {
                md: "4px 0px 14px 0px",
                lg: "4px 16px 14px 0px",
                xl: "4px 16px 14px 0px",
              },
            }}
          >
            {isInvalidEmail
              ? "Email address is invalid"
              : route !== "login" &&
                "For the best experience, use your work email"}
          </FormHelperText>
          <Box
            sx={
              isInvalidEmail
                ? {
                    marginTop: "20px",
                    width: "100%",
                  }
                : {
                    marginTop: route !== "login" ? "20px" : "36px",
                    width: "100%",
                  }
            }
          >
            <Button
              onClick={() => {
                handleContinueButtonOfCheckEmail(email);
              }}
              disabled={isLoading}
              variant="outlined"
              sx={{
                gap: "8px",
                padding: "10px 24px 10px 16px",
                fontSize: "16px",
                width: "100%",
                maxWidth: "340px",
                textTransform: "none",
                bgcolor: button_bg_color_for_New_Project_dm,
                color: "black",
                fontWeight: "600",
                height: "40px",
                fontFamily: "Inter, sans-serif",
                border: "none",
                "&:hover": {
                  bgcolor: "#ffd9aa",
                  border: "none",
                },
                "&:disabled": {
                  bgcolor: button_bg_color_for_New_Project_dm,
                  opacity: 0.7,
                },
              }}
            >
              {isLoading ? <CircularProgress size={24} sx={{ color: "black" }} /> : "Continue"}
            </Button>
            <Typography
              sx={{
                display: "flex",
                fontFamily: "Inter",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "20px",
                color: "var(--or-divider-text)",
                margin: "12px 0px",
                padding: "auto auto",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              OR
            </Typography>
            <Button
              onClick={handleGoogleSignUp}
              variant="outlined"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                padding: "10px 24px 10px 16px",
                fontSize: "16px",
                width: "100%",
                maxWidth: "340px",
                textTransform: "none",
                bgcolor: "var(--google-btn-bg)",
                color: "var(--google-btn-text)",
                fontWeight: "600",
                height: "40px",
                fontFamily: "Inter, sans-serif",
                marginBottom: "60px",
                border: "1px solid var(--border-input)",
                "&:hover": {
                  bgcolor: "var(--google-btn-bg-hover)",
                  border: "1px solid var(--border-input)",
                },
              }}
            >
              <img
                style={{ width: "5%" }}
                src={require(`../../assets/transparent-google-logo-google-logo-with-multicolored-g-and-1710875781697.png`)}
                alt="G"
              />
              Continue with Google
            </Button>
          </Box>

          <Box>
            {
              <FormHelperText
                sx={{
                  width: "100%",
                  maxWidth: "340px",
                  color:
                    "var(--text-link)",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "20px",
                  margin: "4px 0px 14px 0px",
                  alignSelf: "center",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
              >
                {route === "login"
                  ? "Don’t have an account yet? "
                  : "Already have an account? "}
                <span
                  onClick={
                    route === "login"
                      ? handleOpenSignUpModal
                      : handleOpenLoginModal
                  }
                  style={{
                    textDecorationLine: "underline",
                    cursor: "pointer",
                  }}
                >
                  {route === "login" ? "Sign up" : "Log in"}
                </span>
              </FormHelperText>
            }
          </Box>
        </FormControl>
      </Box>
      <CommonToast
        open={open}
        onClose={handleCloseToast}
        content={notifMsg}
        bgColor="var(--toast-bg)"
        fontColor="var(--toast-text)"
        fontSize="14px"
        fontWeight="500"
        autoHideDuration={3000}
        iconType={notifVariant}
      />
    </div>
  );
};

export default SignUpLogInLayout;
